import { Component } from "react"

/* Components */
import { Tag, Cards, Avatar, Pagination, Notes } from "../../components"

/* Widgets */
import { Layout } from "../Table"

/* REST API */
import { game, players, togglePause, end, creditAll } from "../../api/VipThreeBox"

/* Helpers */
import { utils } from "../../helpers"

/* Sweet alert */
import Swal from "sweetalert2"

/* Widgets */
import Player from "./Player"
import { Refunds } from "../Table"

/* Translate */
import { t } from "../../translates/translate"



/* Widget Game Information */
class GameInformation extends Component {

    constructor() {
        super()

        this.state = {
            table: null,
            data: null,
            cards: [],
            status: "loading",

            pstatus: "loading",
            players: [],
            count: 0,
            page: 1,
            number: "",

            visible: false,
            active: null,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Game Information */
    load = (reload = false) => {

        /* Fields */
        const { uid, gameID, postfix } = this.props

        /* Check fields */
        if (!uid || !gameID) {
            this.setState({ status: "error", data: null })
            return
        }

        /* Check reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        game({ uid, gameID, postfix }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.game, table: response.data.table, cards: response.data.cards })
                this.getPlayers()
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: null, table: null, cards: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: null, table: null, cards: [] })
            }
            else {
                this.setState({ status: "error", data: null, table: null, cards: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null, table: null, cards: [] })
        })

    }

    /* Get Players */
    getPlayers = (page = 1, reload = false) => {

        /* Fields */
        const { uid, gameID, postfix } = this.props
        const { number } = this.state

        /* Check Fields */
        if (!uid || !gameID) {
            this.setState({ pstatus: "error", players: [] })
            return
        }

        /* Save Page */
        this.setState({ page })

        /* Reload if need */
        if (reload) {
            this.setState({ pstatus: "loading" })
        }

        /* Get from REST API */
        players({ uid, gameID, page, number, postfix }).then((response) => {
            if (response.status === 200) {
                this.setState({ pstatus: "ok", players: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ pstatus: "permission", players: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ pstatus: "key", players: [], count: 0 })
            }
            else {
                this.setState({ pstatus: "error", players: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ pstatus: "network", players: [], count: 0 })
        })

    }

    /* Search Event */
    search = (event) => {
        event.preventDefault()
        this.getPlayers(1, true)
    }

    /* Set Number */
    setNumber = (number) => {
        if (number === "") {
            this.setState({ number }, () => this.getPlayers(1, true))
        }
        else {
            this.setState({ number })
        }
    }

    /* Get Cards */
    getCards = (type, box = null) => {

        /* Fields */
        const { cards } = this.state
        const list = []

        if (cards && Array.isArray(cards) && cards.length > 0) {
            cards.forEach((card) => {
                if (box !== null) {
                    if (parseInt(card.box) === box) {
                        list.push(card)
                    }
                }
                else if (card.type === type) {
                    list.push(card)
                }
            })
        }

        return list
    }

    /* END action */
    end = (refund = false) => {

        /* Fields */
        const { data } = this.state
        const { uid, gameID, socket, postfix } = this.props

        /* Check */
        if (!uid || !gameID) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        /* Check Status */
        if (parseInt(data.status) === 1) {
            return
        }

        /* Check Paused */
        if (parseInt(data.isPaused) === 1) {
            Swal.fire(utils.notification(t("widget.gamePaused"), "error"))
            return
        }

        Swal.fire({
            title: t("widget.finishConfirmAlt"),
            text: t("widget.finishWarningAlt"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: t("widget.finishConfirmBtn"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                end({ uid, gameID, refund, postfix }).then((response) => {
                    if (response.status === 200) {
                        if (response.data.update === "yes") {
                            socket.emit("end", { refund })
                        }
                        this.load(true)
                        Swal.fire(utils.notification(t("widget.finishDone"), "success"))
                    }
                    else if (response.status === 401 || response.status === 403) {
                        Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                    }
                    else if (response.status === 498) {
                        Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                    }
                    else {
                        Swal.fire(utils.notification(t("swal.generic"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                })
            }
        })


    }



    /* Pause Game */
    pause = () => {

        /* Fields */
        const { data } = this.state
        const { socket, uid, postfix } = this.props

        /* Check Status */
        if (parseInt(data.status) === 1) {
            Swal.fire(utils.notification(t("widget.gameFinished"), "error"))
            return
        }

        /* Check Paused */
        if (parseInt(data.isPaused) === 1) {
            Swal.fire(utils.notification(t("widget.alreadyPaused"), "error"))
            return
        }

        Swal.fire({
            title: t("widget.pauseConfirm"),
            text: t("widget.pauseWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.pauseButton"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                togglePause({ uid, gameID: data.id, type: "pause", postfix }).then((response) => {
                    if (response.status === 200) {

                        if (response.data.update === "yes") {
                            socket.emit("pause", { from: "support" })
                            Swal.fire(utils.notification(t("widget.gamePausedSuccess"), "success", 3000))
                        }
                        else {
                            Swal.fire(utils.notification(t("widget.warningStatusDb"), "success", 4000))
                        }

                        this.load(true)
                    }
                    else {
                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                })
            }
        })

    }

    /* Continue Game */
    continue = () => {

        /* Fields */
        const { data } = this.state
        const { socket, uid, postfix } = this.props

        /* Check Status */
        if (parseInt(data.status) === 1) {
            return
        }

        /* Check Paused */
        if (parseInt(data.isPaused) === 0) {
            Swal.fire(utils.notification(t("widget.gameNotPaused"), "error"))
            return
        }

        Swal.fire({
            title: t("widget.continueConfirm"),
            text: t("widget.continueText"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.continueWithout"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                togglePause({ uid, gameID: data.id, type: "continue", postfix }).then((response) => {
                    if (response.status === 200) {

                        if (response.data.update === "yes") {
                            socket.emit("continue", { type: "continue", gameID: data.id })
                            Swal.fire(utils.notification(t("widget.gameContinued"), "success", 3000))
                        }
                        else {
                            Swal.fire(utils.notification(t("widget.warningStatusDb"), "warning", 3000))
                        }

                        this.load(true)
                    }
                    else {
                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                })
            }
        })

    }

    /* Revoke Cards */
    revoke = () => {

        const { data } = this.state
        const { socket, uid, postfix } = this.props

        if (parseInt(data.status) === 1) {
            return
        }

        if (parseInt(data.isPaused) === 0) {
            Swal.fire(utils.notification(t("widget.gameNotPaused"), "error"))
            return
        }

        Swal.fire({
            title: t("widget.continueConfirm"),
            text: t("widget.resetCardsText"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.resetCards"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                togglePause({ uid, gameID: data.id, type: "continue", postfix }).then((response) => {
                    if (response.status === 200) {

                        if (response.data.update === "yes") {
                            socket.emit("continue", { type: "revoke", gameID: data.id })
                            Swal.fire(utils.notification(t("widget.cardsReset"), "success", 3000))
                        }
                        else {
                            Swal.fire(utils.notification(t("widget.warningStatusDb"), "warning", 3000))
                        }

                        this.load(true)
                    }
                    else {
                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                })
            }
        })

    }

    /* Credit All */
    creditAll = () => {

        /* Fields */
        const { data } = this.state
        const { socket, uid, postfix } = this.props

        Swal.fire({
            title: t("widget.refundAllConfirm"),
            text: t("widget.refundAllWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.refundAllBtn"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                creditAll({ uid, gameID: data.id, postfix }).then((response) => {
                    if (response.status === 200) {
                        const data = response.data
                        Swal.fire(utils.notification(t("widget.refundsComplete"), "success", 3000))
                        socket.emit("refunds", data.refunds)
                        this.load(true)
                    }
                    else {
                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                })
            }
        })

    }


    /* Draw time */
    _time = (time) => {

        const datetime = utils.getTime(time)

        return (
            <div className="page-table-datetime">
                <div className="page-table-time">{datetime.time}</div>
                <div className="page-table-date">{datetime.date}</div>
            </div>
        )
    }


    /* Draw Total */
    _total = () => {

        /* Fields */
        const { data } = this.state

        return (
            <div className="multipoker--game-information-item">
                <img src="/images/game/calculate.png" alt="Calculate" />
                <div className="multipoker--game-information-item-box">
                    <div className="multipoker--game-information-item-title">GGR</div>

                    <div className="multipoker--game-information-item-image-text">
                        <img src="/images/game/increase.png" alt="Credit" />
                        <b>{utils.convertor(data.credit, "$")}</b>
                    </div>

                    <div className="multipoker--game-information-item-image-text">
                        <img src="/images/game/decrease.png" alt="Debit" />
                        <b>{utils.convertor(data.debit, "$")}</b>
                    </div>

                    <div className={`multipoker--game-information-item-text ggr ${parseFloat(data.ggr) > 0 && "green"} ${parseFloat(data.ggr) < 0 && "red"}`}>
                        {parseFloat(data.ggr) > 0 && "+ "}
                        {parseFloat(data.ggr) < 0 && "- "}
                        {utils.convertor(Math.abs(data.ggr), "$")}
                    </div>

                </div>
            </div>
        )
    }


    /* Draw players */
    _players = () => {

        const { number, pstatus, players, page, count } = this.state

        if (pstatus !== "ok") {
            return (
                <div className="game--players">

                    {/* Players Head */}
                    <div className="game--players-head">

                        <div className="game--players-head-title">Players</div>

                        <form onSubmit={this.search} className="game--players-head-form">
                            <input placeholder={t("widget.searchByPlayerNumber")} value={number} onChange={(event) => this.setState({ number: event.target.value })} />
                            <button onClick={() => this.getPlayers(1, true)}><img src="/images/search.png" alt="Search" /></button>
                        </form>

                    </div>

                    <Layout status={pstatus} reload={() => this.getPlayers(1, true)} />

                </div>
            )
        }

        return (
            <div className="game--players">

                {/* Players Head */}
                <div className="game--players-head">

                    <div className="game--players-head-title">Players</div>

                    <form onSubmit={this.search} className="game--players-head-form">
                        <input placeholder={t("widget.searchByPlayerNumber")} value={number} onChange={(event) => this.setNumber(event.target.value)} />
                        <button onClick={() => this.getPlayers(1, true)}><img src="/images/search.png" alt="Search" /></button>
                    </form>

                </div>

                {players && Array.isArray(players) && players.length > 0 &&
                    <div className="game--players-container">
                        {players.map((item, index) =>
                            <div onClick={() => this.setState({ visible: true, active: item })} className="game--players-element" key={`${index}`}>
                                <div className="game--players-element-inner">

                                    <div className="game--players-element-user">
                                        <Avatar uri="/images/player/gamer.png" alt="Gamer" />
                                        <div className="game--players-element-text">
                                            <div className="game--players-element-name">{item.firstName}</div>
                                            <div className="game--players-element-code">{item.player}</div>
                                        </div>

                                        {item.hasOwnProperty("box") ? <p className="game--players-element-box">BOX - {item.box ? item.box : ""}</p> : null}
                                    </div>

                                    <div className="game--players-element-item">
                                        <img src="/images/game/casino.png" alt="Casino" />
                                        <div className="game--players-element-item-text">
                                            <div className="game--players-element-item-name">{t("widget.operator")}</div>
                                            <div className="game--players-element-item-value">{utils.checkValue(item.operator, "")}</div>
                                        </div>
                                    </div>

                                    <div className="game--players-element-item">
                                        <img src="/images/game/dollar-coin.png" alt="Coin" />
                                        <div className="game--players-element-item-text">
                                            <div className="game--players-element-item-name">{t("widget.balance")}</div>
                                            <div className="game--players-element-item-value">{item.startBalance ? utils.convertor(item.startBalance, item.symbol, item.isAfter) : "-"}</div>
                                        </div>
                                    </div>

                                    <div className="game--players-element-item">
                                        <img src="/images/game/dollar-coin.png" alt="Coin" />
                                        <div className="game--players-element-item-text">
                                            <div className="game--players-element-item-name">ANTE</div>
                                            <div className="game--players-element-item-value">{item.ante ? utils.convertor(item.ante, item.symbol, item.isAfter) : "-"}</div>
                                        </div>
                                    </div>

                                    <div className="game--players-element-item">
                                        <img src="/images/game/dollar-coin.png" alt="Coin" />
                                        <div className="game--players-element-item-text">
                                            <div className="game--players-element-item-name">{t("widget.totalBet")}</div>
                                            <div className="game--players-element-item-value">{item.debit ? utils.convertor(item.debit, item.symbol, item.isAfter) : "-"}</div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                }

                {players && Array.isArray(players) && players.length === 0 && <div className="game--players-empty">{t("widget.empty")}</div>}

                <Pagination size={10} page={page} total={count} onPageChange={(page) => this.getPlayers(page, true)} />

            </div>
        )
    }


    render = () => {

        const { status, table, data, visible, active } = this.state
        const { gameID, uid, socket, postfix } = this.props

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        /* Game Fields */
        const datetime = utils.getTime(data.createdAt)

        return (
            <div className="multipoker--game-inner">
                <div className="multipoker--game-information">
                    <div className="multipoker--game-information-row">

                        {/* Game Information */}
                        <div className="multipoker--game-information-element">

                            {/* Name */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/spades.png" alt="Spades" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.game")}</div>
                                    <div className="multipoker--game-information-item-text">{table.name}</div>
                                </div>
                            </div>

                            {/* Number */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/shape.png" alt="Shape" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.gameNumber2")}</div>
                                    <div className="multipoker--game-information-item-text">{data.number}</div>
                                </div>
                            </div>

                            {/* Date */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/clock.png" alt="Clock" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.date")}</div>
                                    <div className="multipoker--game-information-item-text">{datetime.time}, <span>{datetime.date}</span></div>
                                </div>
                            </div>

                            {/* Dealer */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/dealer.png" alt="Dealer" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.dealer")}</div>
                                    <div className="multipoker--game-information-item-text">{data.dealer}</div>
                                </div>
                            </div>

                            {/* Game Status */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/flag.png" alt="Flag" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.gameStatus")}</div>
                                    {parseInt(data.status) === 1 ? <Tag color="blue">{t("widget.completed")}</Tag> : <Tag color="purple">{t("widget.notCompleted")}</Tag>}
                                </div>
                            </div>

                            {/* Pause Status */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/pause.png" alt="Pause" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.pauseStatus")}</div>
                                    {parseInt(data.isPaused) === 1 ? <Tag color="red">{t("widget.paused")}</Tag> : <div className="multipoker--game-information-item-text">-</div>}
                                </div>
                            </div>

                            {/* Update Status */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/tap.png" alt="Tap" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.changeStatus")}</div>
                                    {parseInt(data.isUpdated) === 1 ? <Tag color="pink">{t("widget.changed")}</Tag> : <div className="multipoker--game-information-item-text">-</div>}
                                </div>
                            </div>

                        </div>


                        {/* Player Information */}
                        <div className="multipoker--game-information-element">

                            {/* Players Count */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/group.png" alt="Group" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.playersCount")}</div>
                                    <div className="multipoker--game-information-item-text">{data.players}</div>
                                </div>
                            </div>

                            {/* Transactions Count */}
                            <div className="multipoker--game-information-item">
                                <img src="/images/game/transaction.png" alt="Transaction" />
                                <div className="multipoker--game-information-item-box">
                                    <div className="multipoker--game-information-item-title">{t("widget.transactionCount")}</div>
                                    <div className="multipoker--game-information-item-text">{data.transactions}</div>
                                </div>
                            </div>

                            {/* Total */}
                            {this._total()}

                            <div className="multipoker--game-buttons">
                                <div onClick={() => this._refunds.open(uid, data.roundId)} className="multipoker--game-button refunds">{t("widget.allRefunds")} <img src="/images/arrow.png" alt="Arrow" /></div>
                            </div>

                        </div>

                        {/* Actions */}
                        <div className="multipoker--game-information-big-element">

                            <div className="multipoker--game-information-text">Game actions</div>

                            <div className="multipoker--game-buttons">
                                <div onClick={() => this.end()} className={`multipoker--game-button ${parseInt(data.status) === 1 ? "disabled" : ""}`} >{t("widget.finishGame")}</div>
                                <div onClick={() => this.creditAll()} className="multipoker--game-button gray" >{t("widget.refundAllBets")}</div>
                            </div>

                            <div className="multipoker--game-information-text">Pause actions</div>

                            <div className="multipoker--game-buttons">
                                <div onClick={() => this.pause()} className={`multipoker--game-button blue ${parseInt(data.isPaused) === 1 ? "disabled" : ""}`} >{t("widget.pauseGame")}</div>
                                <div onClick={() => this.revoke()} className={`multipoker--game-button darkblue ${parseInt(data.isPaused) === 0 ? "disabled" : ""}`} >{t("widget.resetCards")}</div>
                                <div onClick={() => this.continue()} className={`multipoker--game-button green ${parseInt(data.isPaused) === 0 ? "disabled" : ""}`} >{t("widget.continueWithout")}</div>
                            </div>

                        </div>

                    </div>


                    {/* Draw Players */}
                    {this._players()}

                    {/* Cards */}
                    <div className="cards--container vip-three-box">
                        <Cards title="Dealer Cards" cards={this.getCards("dealer")} />
                        <Cards title="Additional Cards" cards={this.getCards("additional")} />
                        <Cards title="BOX - 1" cards={this.getCards("player", 1)} />
                        <Cards title="BOX - 2" cards={this.getCards("player", 2)} />
                        <Cards title="BOX - 3" cards={this.getCards("player", 3)} />
                    </div>

                </div>

                {active && <Player postfix={postfix} visible={visible} close={() => this.setState({ visible: false }, () => setTimeout(() => this.setState({ visible: false, active: null }), 200))} active={active} gameID={gameID} uid={uid} socket={socket} />}

                {/* Notes */}
                <Notes uid={uid} gameID={gameID} />

                {/* Draw Refunds */}
                <Refunds ref={(ref) => this._refunds = ref} uid={uid} gameID={gameID} />

            </div>
        )
    }

}

export default GameInformation